module.exports = __webpack_public_path__ + "static/media/dem_exp.54856f49.png";